import { gql } from '@apollo/client'
import client from '../utils/client'
import { MutationHandlerError } from '../utils/errors'

type DeleteRestaurantCommunicationResult =
	| { success: true; errors: null }
	| { success: false; errors: MutationHandlerError }

const deleteRestaurantCommunication = async ({
	id,
}: {
	id: string
}): Promise<DeleteRestaurantCommunicationResult> => {
	try {
		const { data, errors } = await client.mutate({
			mutation: gql`
				mutation DeleteRestaurantCommunication($id: ID!) {
					deleteRestaurantCommunication(id: $id) {
						success
						error
					}
				}
			`,
			variables: { id },
			errorPolicy: 'all',
			refetchQueries: ['RestaurantCommunications', 'RestaurantAlarms'],
		})

		if (errors) return { success: false, errors }
		const result = data?.deleteRestaurantCommunication
		if (!result?.success) {
			return { success: false, errors: result?.error || 'Löschen fehlgeschlagen' }
		}
		return { success: true, errors: null }
	} catch (e) {
		if (e && e.networkError) return { success: false, errors: 'NETWORK_ERROR' }
		throw e
	}
}

export default deleteRestaurantCommunication
